import { CreateUpdateMooringComponent, MooringComponent } from './MooringComponent';

class BaseMooringGridLine {
  MoorlogNo!: string;
  AnalysisNo!: string;
  DimForce?: number;

  StartBuoyId!: number;
  EndBuoyId!: number;

  IsAccident!: boolean;

  MblRopes?: number;
  MblSinkRopes?: number;
  MblStraps?: number;

  MblChainShackleConnectionPlates?: number;
  MblUsedChainRopeWithKnot?: number;

  Length!: number;
  SplicedLength!: number;

  SortIndex!: number;
}

export class UpdateMooringGridLineDto extends BaseMooringGridLine {
  Id!: number;
  Components!: CreateUpdateMooringComponent[];
}

export class AddMooringGridLineDto {
  MoorlogNo!: string;
  AnalysisNo!: string;
  StartBuoyId!: number;
  EndBuoyId!: number;
}

export class MooringGridLine extends BaseMooringGridLine {
  Id!: number;
  Components!: MooringComponent[];

  StartBuoyNo!: string;
  EndBuoyNo!: string;

  HasUnresolvedComments!: boolean;
  HasUnresolvedComponentComments!: boolean;
  HasComments!: boolean;
}

export class MooringProductionGridLineDto {
  Id!: number;
  MooringId!: number;
  MoorlogNo!: string;
  AnalysisNo!: string;
  SplicedLength!: number;
  MblRopes!: number | null;
  MblSinkRopes!: number | null;
  MblChainShackleConnectionPlates!: number | null;
  MblStraps!: number | null;
  Length!: number;
  RopeDimension!: string;
  RopeType!: string;
  RopeMbl!: number;
  RopeUtilizationFactor!: number | null;
  RopeComponentId!: number | null;
  RopeSlot!: MooringProductionGridLineSlotDto | null;
  SpliceStrap!: string;
  Schakle!: string;
  SchakleAmount!: number | null;
  SchakleUtilizationFactor!: number | null;
  SchakleComponentId!: number | null
  SchakleSlot!: MooringProductionGridLineSlotDto | null;
  Thimble!: string;
  ThimbleAmount!: number | null;
  ThimbleUtilizationFactor!: number | null;
  ThimbleComponentId!: number | null;
  ThimbleSlot!: MooringProductionGridLineSlotDto | null;
  SpliceStrapUtilizationFactor!: number | null;
  SpliceStrapAmount!: number | null;
  SpliceStrapComponentId!: number | null;
  SpliceStrapSlot!: MooringProductionGridLineSlotDto | null;
}

export class MooringProductionGridLineSlotDto {
  ComponentId?: number;
  ArticleProductId?: number;
  ProductName?: string;
}

export class MooringProductionGridLineEditDto {
  GridLineId!: number;
  AnalysisNo!: string;
  MblRopes!: number | null;
  MblSinkRopes!: number | null;
  MblChainShackleConnectionPlates!: number | null;
  Length!: number;
  SchakleSlot!: MooringProductionGridLineSlotDto;
  ThimbleSlot!: MooringProductionGridLineSlotDto;
  RopeSlot?: MooringProductionGridLineSlotDto;
  SpliceStrapSlot?: MooringProductionGridLineSlotDto;
}
